import type { SanityGlobalProductVariant } from '@repo/models/gatsby-graphql-types';

const getVariantOptions = (variants: SanityGlobalProductVariant[]) => {
  const optionsFlattened = variants
    .map(variant => variant.selectedOptions)
    .flat(1);

  const builtOptions = optionsFlattened.reduce(
    (resultSoFar, { name, value }) => {
      let bin = resultSoFar.find(e => e.name === name);

      if (!bin) {
        bin = { name, values: new Set() };
        resultSoFar.push(bin);
      }
      bin.values.add(value);
      return resultSoFar;
    },
    []
  );

  builtOptions.forEach(e => {
    e.values = [...e.values];
  });

  return builtOptions;
};

export default getVariantOptions;
